module.exports = __webpack_public_path__ + "static/assets/a6b8c319c8e07f80534adfb48d3610d8.svg";